import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { motion } from 'framer-motion';
import { fadeInUp } from '@/motion/variants';

// Demo data for 24-month seasonality pattern
const seasonalityData = [
  { month: 'Jan', value: 65, normal: 60 },
  { month: 'Feb', value: 68, normal: 62 },
  { month: 'Mar', value: 72, normal: 65 },
  { month: 'Apr', value: 75, normal: 68 },
  { month: 'May', value: 82, normal: 75 },
  { month: 'Jun', value: 88, normal: 80 },
  { month: 'Jul', value: 85, normal: 78 },
  { month: 'Aug', value: 78, normal: 72 },
  { month: 'Sep', value: 75, normal: 70 },
  { month: 'Oct', value: 72, normal: 68 },
  { month: 'Nov', value: 68, normal: 65 },
  { month: 'Dec', value: 65, normal: 62 },
  { month: 'Jan', value: 67, normal: 60 },
  { month: 'Feb', value: 70, normal: 62 },
  { month: 'Mar', value: 74, normal: 65 },
  { month: 'Apr', value: 77, normal: 68 },
  { month: 'May', value: 84, normal: 75 },
  { month: 'Jun', value: 90, normal: 80 },
  { month: 'Jul', value: 87, normal: 78 },
  { month: 'Aug', value: 80, normal: 72 },
  { month: 'Sep', value: 77, normal: 70 },
  { month: 'Oct', value: 74, normal: 68 },
  { month: 'Nov', value: 70, normal: 65 },
  { month: 'Dec', value: 67, normal: 62 }
];

const SeasonalityCard = () => {
  return (
    <motion.div
      variants={fadeInUp}
      initial="initial"
      animate="animate"
      className="bg-card/50 border border-border/50 p-6 rounded-lg shadow-sm"
    >
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-slate-900 mb-1">
          Seasonality Pattern
        </h3>
        <p className="text-sm text-slate-600">
          24-Month Price Trend Analysis
        </p>
        <p className="text-xs text-slate-500 mt-1">
          Illustrative data - Historical patterns
        </p>
      </div>

      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={seasonalityData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
            <XAxis
              dataKey="month"
              tick={{ fontSize: 12, fill: '#64748b' }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={{ fontSize: 12, fill: '#64748b' }}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                fontSize: '12px'
              }}
            />
            <Area
              type="monotone"
              dataKey="value"
              stroke="#10b981"
              fill="#10b981"
              fillOpacity={0.3}
              strokeWidth={2}
              name="Current Trend"
            />
            <Area
              type="monotone"
              dataKey="normal"
              stroke="#94a3b8"
              fill="#94a3b8"
              fillOpacity={0.2}
              strokeWidth={1}
              strokeDasharray="5 5"
              name="Normal Range"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 text-xs text-slate-500">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-emerald-500 rounded"></div>
            <span>Current Trend</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-slate-400 rounded opacity-60"></div>
            <span>Normal Range</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SeasonalityCard;
